import React from 'react';
import Content from './Content';
import { Button, Container, Stack } from '@mui/material';
import PublicAppBar from './PublicAppBar';
import { DiscussionEmbed } from 'disqus-react';
import { useLocation, useParams } from 'react-router-dom';
import { isFunctionEligible } from '../../helpers/eligibilityChecker';
import CheckIcon from '@mui/icons-material/Reviews';
import EditIcon from '@mui/icons-material/Edit';

const PublicIndex = ({ userInfo }) => {
  const params = useParams();
  const location = useLocation();

  const navigateTo = (id) => {
    const host = process.env.REACT_APP_STAGE === 'PRODUCTION' ? process.env.REACT_APP_HOST_PROD : process.env.REACT_APP_HOST;
    if (id === 'edit') return window.open(`${host}/portal/moderation/detail?id=${params.id}`);
    if (id === 'review') return window.open(`${host}/portal/moderation/review/${params.id}`);
  };

  return (
    <Stack direction='column'>
      <PublicAppBar />
      {isFunctionEligible(userInfo.type, 'button_review_edit') && (
        <Stack sx={{ alignSelf: 'center', paddingTop: 3 }} direction='row' spacing={1} alignItems='center'>
          <Button onClick={() => navigateTo('review')} startIcon={<CheckIcon />} variant='outlined' size='small'>
            Review
          </Button>
          <Button onClick={() => navigateTo('edit')} startIcon={<EditIcon />} variant='outlined' size='small'>
            Edit
          </Button>
        </Stack>
      )}

      <Content />
      <Container>
        <DiscussionEmbed
          shortname='sdgs-best-practice'
          config={{
            url: `https://domes.un.or.id/public/${params.id}`,
            identifier: params.id,
            title: location.pathname,
            language: 'ID', //e.g. for Traditional Chinese (Taiwan)
          }}
        />
      </Container>
    </Stack>
  );
};

export default PublicIndex;
